var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimeWithBackground = function SvgTimeWithBackground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#E5F3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.529 37.473a.8.8 0 0 0 .106-1.127l-3.833-4.632v-7.777a.8.8 0 0 0-1.6 0v8.066a.8.8 0 0 0 .183.51l4.017 4.853a.798.798 0 0 0 1.127.107ZM32.002 19.4c-6.948 0-12.601 5.654-12.601 12.603C19.4 38.949 25.054 44.6 32 44.6c6.948 0 12.6-5.651 12.6-12.597 0-6.95-5.652-12.603-12.6-12.603Zm0 26.8C24.17 46.2 17.8 39.83 17.8 32.003 17.8 24.172 24.17 17.8 32 17.8c7.83 0 14.2 6.372 14.2 14.203C46.2 39.83 39.83 46.2 32 46.2Z",
    fill: "url(#time-with-background_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "time-with-background_svg__a",
    x1: 17.801,
    y1: 17.8,
    x2: 46.2,
    y2: 46.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4A93E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#504CCB"
  })))));
};
export default SvgTimeWithBackground;